import React from "react";
import Heading from "../../components/common/Typography/Heading";
import Paragraph from "../../components/common/Typography/Paragraph";

const CreatePostLeftText = ({ heading, text }) => {
  return (
    <>
      <div className="flex flex-col lg:flex-row items-center justify-between gap-x-16 mx-[5%] xl:mx-auto xl:w-[1100px] 2xl:w-[1264px] mt-10 sm:mt-20">
        <div className="mt-7 sm:mt-10 lg:my-auto order-2 lg:order-1">
          <div>
            <Heading variant={"h2"} className={"text-offblack"}>
              {heading}
            </Heading>
            <Heading variant={"h6"} className={"mt-3"}>
              {text}
            </Heading>
          </div>
        </div>
        <div className="order-1 lg:order-2 h-auto w-full lg:w-1/2 aspect-square shrink-0">
          <img
            className="object-cover w-full h-full rounded-xl"
            src={require("../../assets/img/TradesPosterSpeciality/businesses.jpg")}
            alt="trade-poster"
          />
        </div>
      </div>
    </>
  );
};

export default CreatePostLeftText;
